import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-stone-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_site-generator-110/artifacts/jak8psts_FB_IMG_1771620544400.jpg" 
              alt="Barkatis Group" 
              className="h-12 w-auto mb-4 bg-white p-2 rounded"
            />
            <p className="text-gray-300 text-sm">
              Un héritage d'excellence depuis 1993
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <div className="flex items-start space-x-2">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>Zone Industrielle Sidi Salem, Route de Gabes km 3, Sfax, Tunisie</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail size={16} />
                <a href="mailto:contact@barkatis-group.com" className="hover:text-amber-400">contact@barkatis-group.com</a>
              </div>
              <div className="flex items-center space-x-2">
                <Phone size={16} />
                <span>+216 36 400 920</span>
              </div>
            </div>
          </div>

          {/* Divisions */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Nos Pôles</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Pôle Agro-Alimentaire</li>
              <li>Pôle Industrie & Technique</li>
              <li>Pôle Art & Design</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Barkatis Group. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;